/* eslint-disable class-methods-use-this */
/* eslint-disable no-magic-numbers */
import Phase from '../phase-core/Phase';

export default class HeadTurnCircle extends Phase {
	getPreludeLength() {
		return 1/4;
	}
	getPostludeLength() {
		return 0;
	}
	run({ time, pulse, headshot_opts }) {
		const t = time.relative + 1/4;
		const θ = t % 2 * Math.PI;
		headshot_opts.hyper[0] = Math.sin(θ);
		headshot_opts.hyper[1] = Math.cos(θ);
	}
}
